import { Select } from "@JohnLewisPartnership/jl-design-system/dist/components/select/Select";
import styles from "./Sort.module.scss";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import classnames from "classnames/bind";
import { useRouter } from "next/router";
import { ChangeEvent, useEffect, useState } from "react";
import { sortOptions } from "./SortOptions";
import { SORT_OPTION_CHANGED } from "@/utils/events";
import { dispatchLegacyAnalyticsEvent } from "@/utils/analytics";
import { StandardProps } from "@/types/types";
import { getAnalyticsPageType } from "@/utils/setJLData";
import { useFeatureFlags } from "@/flags/flags";
import { useRouteParams } from "@/hooks/useRouteParams";
import { sanitiseQueryParams } from "@/utils/queryUtils";

const cx = classnames.bind(styles);

export function Sort({
  productListingData,
  configProps,
}: Pick<StandardProps, "productListingData" | "configProps">) {
  const { queryWithoutPageOrChunk, pageType, path } = useRouteParams();
  const { isTabletEnhancementsFlagOn } = useFeatureFlags();
  const router = useRouter();

  const [isInteractive, setIsInteractive] = useState(false);

  useEffect(() => {
    setIsInteractive(true);
  }, []);

  const existingSort = queryWithoutPageOrChunk.sortBy;

  const handleSort = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    const sortBy = e.target.value;

    dispatchLegacyAnalyticsEvent(SORT_OPTION_CHANGED, {
      pagetype: getAnalyticsPageType(pageType, productListingData.results),
      sort: sortBy,
    });

    router.push({
      pathname: path,
      query: sanitiseQueryParams({ ...queryWithoutPageOrChunk, sortBy }),
    });
  };

  return (
    <div
      className={cx("sort", {
        sort__tabletEnhancements: isTabletEnhancementsFlagOn?.value,
      })}
    >
      <form action={path} method="GET" className={cx("sort__form")}>
        {Object.entries(queryWithoutPageOrChunk).map(
          ([name, value]) =>
            name !== "sortBy" && (
              <input key={name} name={name} value={value} type="hidden" />
            ),
        )}
        <div className={cx("sort__select")} data-testid="sort-by">
          <label className={styles.visuallyHidden} htmlFor="sortBy">
            Sort by
          </label>
          <Select
            id="sortBy"
            name="sortBy"
            labelText=""
            showLabel={false}
            value={(configProps?.sort as string) || existingSort || ""}
            onChange={handleSort}
            data-testid="sortBySelect"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
        <PrimaryButton
          type="submit"
          className={cx("sort__submit", {
            "sort__submit--visible": !isInteractive,
          })}
        >
          Go
        </PrimaryButton>
      </form>
    </div>
  );
}
